import React, { useState } from 'react';
import {
  FaBars,
  FaTimes,
  FaPhoneAlt,
  FaMailBulk,
  FaMailchimp,
  FaEnvelope,
} from 'react-icons/fa';

import { Link } from 'react-router-dom';

import './navcomp.css';

function NavComp() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  const closeMenu = () => setIsOpen(false);

  return (
    <nav className="navbar">
      
      {/* Top Bar */}
      <div className="top-bar">
        <div className="container">

          <div className="contact-info">
            <a href="tel:+94771199190" className="phone-link">
              <FaPhoneAlt className="icon" />
              077 119 9190
            </a>
          </div> &nbsp; &nbsp; &nbsp;


                    <div className="contact-info">
            <a href="mailto:info@drjerymedico.com" className="phone-link">
              <FaEnvelope className="icon" />
              info@drjerymedico.com
            </a>
          </div>

        </div>
      </div>

      {/* Main Navigation */}
      <div className="main-nav">
        <div className="container">

          {/* Logo */}
          <div className="logo">
            <Link to="/" onClick={closeMenu}>
              <img
                src="/logo.png"
                alt="Dr. Jery Medico Logo"
                className="logo-img"
              />
            </Link>
          </div>

          {/* Navigation */}
          <ul className={`nav-links ${isOpen ? 'active' : ''}`}>

            <li>
              <Link to="/" onClick={closeMenu}>
                Home
              </Link>
            </li>

            {/* Dropdown */}
            <li className="dropdown">

              <span className="dropdown-title">
                Main Divisions ▼
              </span>

              <ul className="dropdown-menu">

                <li>
                  <Link
                    to="/medical-advisory-applied-psychology"
                    onClick={closeMenu}
                  >
                    Medical Advisory & Applied Psychology
                  </Link>
                </li>

                <li>
                  <Link
                    to="/medico-legal-medical-ethics"
                    onClick={closeMenu}
                  >
                    Medico Legal & Medical Ethics
                  </Link>
                </li>

                  <li>
                  <Link
                    to="/biomedical-engineering-and-sports-biomechanics-advisory"
                    onClick={closeMenu}
                  >
                    Biomedical Engineering &
                    Sports Biomechanics Advisory
                  </Link>
                </li>


                <li>
                  <Link
                    to="/AI-health-informatics-csr-health-services"
                    onClick={closeMenu}
                  >
                    AI Health Informatics CSR Health Services
                  </Link>
                </li>


                <li>
                  <Link
                    to="/digital-health-accessories-wellness-and-sports-biomechanics-solutions"
                    onClick={closeMenu}
                  >
                    Digital Health Accessories Wellness &
                    Sports Biomechanics Solutions
                  </Link>
                </li>




              </ul>
            </li>

            <li>
              <Link to="/aboutus" onClick={closeMenu}>
                About
              </Link>
            </li>

            <li>
              <Link to="/faq" onClick={closeMenu}>
                FAQ
              </Link>
            </li>

            <li>
              <Link to="/contactus" onClick={closeMenu}>
                Contact
              </Link>
            </li>

                        <li>
              <Link to="/booking" onClick={closeMenu}>
                Book An Appointment
              </Link>
            </li>

          </ul>

          {/* Mobile Toggle */}
          <div className="mobile-toggle" onClick={toggleMenu}>
            {isOpen ? <FaTimes /> : <FaBars />}
          </div>

        </div>
      </div>
    </nav>
  );
}

export default NavComp;